import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=23e20344&scoped=true&"
import script from "./AddNote.vue?vue&type=script&lang=ts&"
export * from "./AddNote.vue?vue&type=script&lang=ts&"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=23e20344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e20344",
  null
  
)

export default component.exports